import { defineMessages } from '@jutro/locale';

export default defineMessages({
    activityDetail: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Add Follow-up',
        defaultMessage: 'Add Follow-up'
    },
    closeModal: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.CLOSE',
        defaultMessage: 'CLOSE'
    },
    cancel: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.CANCEL',
        defaultMessage: 'CANCEL'
    },
    dueDate: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Due Date',
        defaultMessage: 'Due Date'
    },
    category: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Category',
        defaultMessage: 'Category'
    },
    subject: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Subject',
        defaultMessage: 'Subject'
    },
    description: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Description',
        defaultMessage: 'Description'
    },
    type: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Type',
        defaultMessage: 'Type'
    },
    status: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Status',
        defaultMessage: 'Status'
    },
    priority: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Priority',
        defaultMessage: 'Priority'
    },
    assignedTo: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Assigned To',
        defaultMessage: 'Assigned To'
    },
    saveBtn: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.SAVE',
        defaultMessage: 'SAVE'
    },
    self: {
        id: 'ml.gateway.views.ActivityReports.MLAddActivityPopup.Self',
        defaultMessage: 'Self'
    }
});
